import React from 'react'

const RegistrationForm = () => {

  const registrationFormLink = "https://docs.google.com/forms/d/e/1FAIpQLSdFnjRYZzcbehXV7bBhg_68CxRhiiv8leKm2gYSdAzNzh5dbw/viewform?usp=dialog"
  return (
    <section id='iscriviti' className='w-screen bg-brand-black px-6 md:px-8 xl:px-[8vw] pt-12 sm:pt-16 lg:pt-24 pb-12 flex flex-col items-center'>

        <article className='sm:w-max'>
            <p className='font-mono text-brand-blue uppercase'>// Register</p>
            <h2 className='uppercase text-brand-white font-display font-black text-5xl sm:text-[clamp(2.4rem,6vw,6.5rem)] leading-none'>REGISTER NOW!</h2>
        </article>

        <article className='md:w-min md:pr-48 mt-12 border border-brand-white/40 hover:border-brand-blue duration-300 hover:-translate-y-3 rounded-md p-8 md:p-12 flex flex-col gap-6'>
            <h4 className='text-4xl md:text-5xl font-black text-brand-white font-display uppercase sm:text-nowrap'>SIGN IN TO REGISTER</h4>
            <p className='text-brand-white/50 font-display text-xl'>Sign in with Google to fill out the form. Each member of the team must fill the form, not just the team leader. If you don't have a team,  we will assign you to one with available spots.</p>
            <a href={registrationFormLink} target="_blank" rel="noopener noreferrer" className='w-max blue-btn uppercase font-mono px-6 py-4'>SIGN IN WITH GOOGLE</a>
        </article>
    </section>
  )
}

export default RegistrationForm